import React from "react";
import { connect } from "react-redux";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import paidCategories from "../../../paidCategories.json";
import * as actions from "../../../store/actions";
import { firestore } from "../../../firebase";

import PremiumCategory from "./PremiumCategory/PremiumCategory";

import classes from "./PremiumCategories.module.css";

const PremiumCategories = ({
  purchased,
  includeNSFW,
  userId,
  selectPaidCategory,
  onSetSettingsModal,
  onSetCurrentCategory,
  onSetIncludeNSFW,
}) => {
  const categoryClicked = (index, isPurchased) => {
    if (isPurchased) {
      onSetCurrentCategory(paidCategories[index].name);
    } else {
      selectPaidCategory(index);
    }
    onSetSettingsModal(false);
  };

  const changeIncludeNSFW = (include) => {
    onSetIncludeNSFW(include);
    firestore.collection("users").doc(userId).update({ includeNSFW: include });
  };

  return (
    <div className={classes.PremiumCategories}>
      <h1>Premium categories</h1>
      <p>
        The Art Prompts web app offers <strong>4 premium categories</strong>,
        that can be purchased by clicking on their respective buttons below.
        Note that to unlock the NSFW category, you have to confirm you are 18
        years or older.
      </p>
      <div className={classes.CategoriesContainer}>
        {paidCategories.map((category, index) => {
          const isPurchased = purchased.includes(category.name) ? true : false;
          return (
            <PremiumCategory
              key={category.name}
              name={category.name}
              image={
                require(`../../../illustrations/${category.image}`).default
              }
              purchased={isPurchased}
              clicked={() => categoryClicked(index, isPurchased)}
            />
          );
        })}
      </div>
      {purchased.includes("NSFW") ? (
        <FormControlLabel
          control={
            <Checkbox
              checked={includeNSFW}
              onChange={(event) => changeIncludeNSFW(event.target.checked)}
              className={classes.Checkbox}
            />
          }
          label="Include NSFW prompts in the All Prompts category."
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userId: state.userId,
  purchased: state.purchased,
  includeNSFW: state.includeNSFW,
});

const mapDispatchToProps = (dispatch) => ({
  onSetSettingsModal: (show) => dispatch(actions.setSettingsModal(show)),
  onSetCurrentCategory: (category) =>
    dispatch(actions.setCurrentCategory(category)),
  onSetIncludeNSFW: (include) => dispatch(actions.setIncludeNSFW(include)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PremiumCategories);
